import noImageSVg from '../assets/img/no-image.svg';
export const error_400 = messageObj => {
  let message = '';
  Object.entries(messageObj).forEach(([key, value]) => {
    message = message + key + ' : ' + value.toString() + '\n';
  });
  return message;
};

export const handleError = error => {
  let message = '';
  if (error.response) {
    // Request made and server responded
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 401)
      window.location.href = (process.env.REACT_APP_SUB_PATH ?? '/') + 'login';

    message = error_400(error.response.data);
  } else if (error.request) {
    // The request was made but no response was received
    console.log(error.request);
    message = 'No response recieved!';
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
    message = 'Server error!';
  }
  return message;
};

export const default_image_path = () => {
  return noImageSVg;
};

export const getProfile = () => {
  let profile = JSON.parse(localStorage.getItem('profile'));
  return profile
    ? profile
    : {
        username: '',
        full_name: '',
        photo: null,
      };
};
